<div class="navbar">
  <div class="logo-container" (click)="logoLink()">
    <div class="logo"></div>
  </div>
  <button *ngIf="isMinasidor" (click)="goBackToMinasidor()" class="mat-typography return-button">
    {{ "summary.buttonText.minasidorSubmit" | translate }}
  </button>
</div>
